import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Modal from 'react-bootstrap/Modal'
import { useState } from "react";
import './blc_gallery_one.css';
import Blc_Gallery_Two from "./Blc_Gallery_Two";


const Blc_Gallery_One = (props) => {
  const [show, setShow] = useState(false);
  const [blcIndex, setBlcIndex] = useState(0);
  // console.log(props.valGalleryThree[0]);
  const sectionTitle = props.valGalleryTwo.Title.split(" ");
  
  return (
      <section id="gallery-one">
        <Container>
          <div>
            {/* <h2 className=" mt-3 text-start">{props.valGalleryTwo.Title}</h2> */}
            <h2 className="sectionHeading titles">
              <span className='titles-black me-2'>{sectionTitle[0]}</span>
              <span className='titles-black me-2'>{sectionTitle[1]}</span>
              <span className='titles-black me-2'>{sectionTitle[2]}</span>
              <span className='titles-black me-2'>{sectionTitle[3]}</span>
              <span className='titles-black me-2'>{sectionTitle[4]}</span>
              <span className="me-2">{sectionTitle[5]}</span>
              <span className="me-2">{sectionTitle[6]}</span>
              <span>{sectionTitle[7]}</span>

            </h2>
            {/* <hr style={{ height: '3px', width: '100%', color: 'dark' }} /> */}
          </div>
          <Row className="g-4">
            {props.valGalleryTwo.gallery_cardname.map((data, index) => (
              <Col xs={12} sm={12} md={6} lg={3} className="galleryOneCol d-flex justify-content-start" key={index} >
                <Card className="text-white gallery-card"
                  onClick={() => { setShow(true); setBlcIndex(index) }}
                  style={{ width: '100%', border: 'none' }}>
                  <Card.Img className="gallery-card-thumbnail" src={data.card_img.data[0].attributes.formats.thumbnail.url} />
                  <Card.ImgOverlay>
                    <div className="gallery-card-title-overlay">
                      <div className="gallery-title-container">
                        <Card.Title className="each-gallery-title">{data.gallery_name}</Card.Title>
                      </div>
                    </div>
                  </Card.ImgOverlay>
                </Card>
              </Col>
            ))}
          </Row>
          <Modal
            show={show}
            onHide={() => setShow(false)}
            dialogClassName="modal-90w my-modal blcGallery"
            aria-labelledby="example-custom-modal-styling-title"

          >
            <Modal.Header closeButton>
              <Modal.Title id="example-custom-modal-styling-title">
                {props.valGalleryThree[blcIndex].title}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="gallery-modal">
              <Container>
                <Blc_Gallery_Two valEachBlc={props.valGalleryThree[blcIndex]} />
              </Container>
            </Modal.Body>
          </Modal>
        </Container>
      </section>
  );
};

export default Blc_Gallery_One;
